import { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

export const PageTransition = ({ children }: PageTransitionProps) => {
  return <div className="relative min-h-full w-full overflow-x-clip">{children}</div>;
};
